export default "__VITE_ASSET__31ed0700__"